import { render, staticRenderFns } from "./OTSection.vue?vue&type=template&id=53634f90&scoped=true&lang=pug"
import script from "./OTSection.vue?vue&type=script&lang=js"
export * from "./OTSection.vue?vue&type=script&lang=js"
import style0 from "./OTSection.vue?vue&type=style&index=0&id=53634f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53634f90",
  null
  
)

export default component.exports